import {useQuery} from "@tanstack/react-query";
import {readOrderStatus} from "../../../../../api/main/DashboardApi";
import {dashboardOrderStatusInit} from "../state";

export const useReadOrderStatus = () => {
    const {data} = useQuery({
        queryKey: ["readOrderStatus"],
        queryFn: async () => await readOrderStatus(),
        select: (res) => res?.data.result ?? dashboardOrderStatusInit,
    });

    return {data};
};
